import type { ColumnsType } from "antd/es/table";

export function createColumns(): ColumnsType<any> {
  return [
    {
      title: "LE00",
      dataIndex: "le00",
      key: "le00",
      width: 120,
    },
    {
      title: "LE01",
      dataIndex: "le01",
      key: "le01",
      width: 120,
    },
    {
      title: "LE02",
      dataIndex: "le02",
      key: "le02",
      width: 100,
    },
    {
      title: "LE03",
      dataIndex: "le03",
      key: "le03",
      width: 120,
    },
    {
      title: "LE04",
      dataIndex: "le04",
      key: "le04",
      width: 150,
    },

    {
      title: "LE05",
      dataIndex: "le05",
      key: "le05",
      width: 100,
    },
    {
      title: "LE06",
      dataIndex: "le06",
      key: "le06",
      width: 100,
    },
    {
      title: "LE07",
      dataIndex: "le07",
      key: "le07",
      width: 100,
    },
    {
      title: "LE08",
      dataIndex: "le08",
      key: "le08",
      width: 100,
    },
    {
      title: "LE09",
      dataIndex: "le09",
      key: "le09",
      width: 100,
    },
    {
      title: "LE10",
      dataIndex: "le10",
      key: "le10",
      width: 100,
    },
    {
      title: "LE11",
      dataIndex: "le11",
      key: "le11",
      width: 150,
    },
    {
      title: "LE12",
      dataIndex: "le12",
      key: "le12",
      width: 180,
    },
    {
      title: "LE13",
      dataIndex: "le13",
      key: "le13",
      width: 100,
    },
    {
      title: "LE14",
      dataIndex: "le14",
      key: "le14",
      width: 100,
    },
    {
      title: "LE15",
      dataIndex: "le15",
      key: "le15",
      width: 120,
    },
    {
      title: "LE16",
      dataIndex: "le16",
      key: "le16",
      width: 100,
    },
    {
      title: "LE17",
      dataIndex: "le17",
      key: "le17",
      width: 100,
    },
    {
      title: "LE18",
      dataIndex: "le18",
      key: "le18",
      width: 100,
    },
    {
      title: "LE19",
      dataIndex: "le19",
      key: "le19",
      width: 100,
    },
    {
      title: "LE20",
      dataIndex: "le20",
      key: "le20",
      width: 100,
    },
    {
      title: "LE21",
      dataIndex: "le21",
      key: "le21",
      width: 100,
    },
    {
      title: "ZIP",
      dataIndex: "zip",
      key: "zip",
      width: 100,
    },
    {
      title: "EMail",
      dataIndex: "email",
      key: "email",
      width: 180,
    },
    {
      title: "Memo",
      dataIndex: "memo",
      key: "memo",
      width: 100,
    },
    {
      title: "MPhone",
      dataIndex: "mphone",
      key: "mphone",
      width: 120,
    },
    {
      title: "AID",
      dataIndex: "aid",
      key: "aid",
      width: 100,
    },
    {
      title: "Ref Leads No",
      dataIndex: "refLeadsNo",
      key: "refLeadsNo",
      width: 100,
    },
    {
      title: "Reg Time",
      dataIndex: "regTime",
      key: "regTime",
      width: 150,
    },
    {
      title: "SID",
      dataIndex: "sid",
      key: "sid",
      width: 100,
    },
    {
      title: "Mark",
      dataIndex: "mark",
      key: "mark",
      width: 100,
    },
    {
      title: "Birth Max",
      dataIndex: "birthMax",
      key: "birthMax",
      width: 120,
    },
    {
      title: "Birth Min",
      dataIndex: "birthMin",
      key: "birthMin",
      width: 120,
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      width: 100,
    },
    {
      title: "Preg",
      dataIndex: "preg",
      key: "preg",
      width: 100,
    },
    {
      title: "FFP",
      dataIndex: "ffp",
      key: "ffp",
      width: 100,
    },
    {
      title: "DVD Flag",
      dataIndex: "dvdFlag",
      key: "dvdFlag",
      width: 100,
    },
  ];
}
